import { createSelectorHook, createDispatchHook } from 'react-redux';
/**
 * Redux Hooks Plugin
 *
 * generates redux hooks for store
 */
export default (function (_a) {
    var context = _a.context;
    var useSelector = createSelectorHook(context);
    var useDispatch = createDispatchHook(context);
    return {
        onStoreCreated: function () {
            return {
                useSelector: useSelector,
                useDispatch: useDispatch,
            };
        },
    };
});
